<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
		 <b-col class="p-0">
			<!--<b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<!--<h3>Import Stocks</h3> -->
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-link class="mr-4" href="https://www.alluraa.com/samples/import-stock.csv" download>Sample CSV</b-link>
                    <b-button variant="dark" pill  @click="triggerimportcsv()"><b-icon class="mr-2" icon="upload" aria-hidden="true"></b-icon>Upload CSV</b-button>
                    <b-form-file type="file" class="importfile" style="display:none" v-model="product_csv" accept=".csv" @change="uploadfile($event)"></b-form-file>
					<download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsList" name="stock_list.csv" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export Stock List CSV</download-csv> 
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
										<b-badge pill variant="success" v-else-if="row.value == 1">COMPLETE</b-badge>
										<b-badge pill variant="success" v-else>COMPLETE</b-badge>
									</template>
                                    <template v-slot:cell(records)="row">
										<b-table show-empty sticky-header small striped outlined stacked="md" :items="JSON.parse(row.value)" :fields="itemfields">
                                            <template v-slot:cell(status)="row1">
                                                <b-badge pill variant="warning" v-if="row1.value == 0">CANCELED</b-badge>
                                                <b-badge pill variant="success" v-else-if="row1.value == 1">COMPLETE</b-badge>
                                            </template>
                                            <template v-slot:cell(insert_time)="row1">
                                                <span>{{row1}}</span>
                                            </template>
                                        </b-table>
									</template>
									<template v-slot:cell(summary)="row">
										<ul style="padding: 0px; margin:0px;"><li>Total Records: {{JSON.parse(row.value).total_record}}</li><li>Total Success: {{JSON.parse(row.value).total_success}}</li><li>Total Failed: {{JSON.parse(row.value).total_fail}}</li></ul>
									</template>
                                    <template v-slot:cell(insert_time)="row">
										<span>{{$moment(row.value).format("DD-MM-YYYY HH:mm:ss")}}</span>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1">View Report{{row.value}}</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
	</div>
	
</template>
<script>
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_csv: null,
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'sellerapi/importstock-reload',
			insertUrl: this.$root.NEWAPIURL+'sellerapi/stockimport',
			//insertUrl: this.$root.NEWAPIURL+'sellerapi/updaateAttriutBySku', for Update Attribut
			recordsList:[],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
                { key: 'id', label: 'ID'},
                { key: 'summary', label: 'Summary'},
				{ key: 'insert_time', label: 'Insert Time'},
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
            ],
            itemfields:[
                { key: 'product_id', label: 'PID'},
                { key: 'sku', label: 'SKU'},
                { key: 'total_images', label: 'TOTAL IMAGES'},
				{ key: 'status', label: 'Status' },
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {
		
        triggerimportcsv(){
            //this.$refs.importfile.click();
            document.getElementsByClassName('importfile')[0].querySelector('input').click();
        },
        uploadfile(event){
            var self = this;
            self.loading = true;
            
            let formData = new FormData();
            formData.append('csvfile', document.getElementsByClassName('importfile')[0].querySelector('input').files[0]);
            formData.append('accesskey', this.$session.get('access_key'));

            self.axios.post(self.insertUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0') {
                            self.$bvModal.hide('my-model');
                            self.$bvToast.toast(response.data.message, {
                                    title: 'Status',
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 5000,
                                    variant: 'warning',
                                    solid: true,
                                    appendToast: true
                            });
                            self.initload();
                    }
                    event.target.value = '';
            }).catch(function (error) {
                alert(error);
            });
        },
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;					
					self.loading = false;
					self.totalRows = self.records.length;
					self.recordsList = response.data.result.recordsCsv;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		importcsv(){
			//fdhgkjhg
		}
	}
}
</script>
<style>
</style>